<template>
    <div
        class="relative group inline-block cursor-pointer focus:outline-none"
        tabindex="0"
        :aria-describedby="id"
    >
        <slot></slot>

        <div
            :id="id"
            role="tooltip"
            class="absolute top-full left-1/2 mt-2 w-max -translate-x-1/2 transform rounded bg-gray-800 text-white text-xs px-2 py-1 opacity-0 group-hover:opacity-100 group-focus:opacity-100 transition-opacity duration-200 z-400 pointer-events-none"
        >
            {{ text }}
            <!-- Arrow pointing up -->
            <div
                class="absolute -top-2 left-1/2 -translate-x-1/2 w-0 h-0 border-x-8 border-x-transparent border-b-8 border-b-gray-800"
            ></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Tooltip',
        props: {
            text: {
                type: String,
                required: true,
            },
            id: {
                type: String,
                default() {
                    return `tooltip-${Math.random().toString(36).substr(2, 9)}`;
                },
            },
        },
    };
</script>
